var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    fill: "white",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0859 13.4514L20.0643 8.48455C20.2824 8.26653 20.4048 7.97084 20.4048 7.66252C20.4048 7.3542 20.2824 7.05851 20.0643 6.84049C19.8463 6.62248 19.5506 6.5 19.2423 6.5C18.934 6.5 18.6383 6.62248 18.4203 6.84049L13.4534 11.819L8.48652 6.84049C8.26851 6.62248 7.97282 6.5 7.6645 6.5C7.35618 6.5 7.06048 6.62248 6.84247 6.84049C6.62446 7.05851 6.50198 7.3542 6.50198 7.66252C6.50198 7.97084 6.62446 8.26653 6.84247 8.48455L11.8209 13.4514L6.84247 18.4183C6.73395 18.526 6.64782 18.654 6.58904 18.7951C6.53026 18.9362 6.5 19.0875 6.5 19.2403C6.5 19.3932 6.53026 19.5445 6.58904 19.6856C6.64782 19.8267 6.73395 19.9547 6.84247 20.0624C6.9501 20.1709 7.07815 20.257 7.21924 20.3158C7.36033 20.3746 7.51165 20.4048 7.6645 20.4048C7.81734 20.4048 7.96867 20.3746 8.10975 20.3158C8.25084 20.257 8.37889 20.1709 8.48652 20.0624L13.4534 15.0839L18.4203 20.0624C18.5279 20.1709 18.656 20.257 18.7971 20.3158C18.9382 20.3746 19.0895 20.4048 19.2423 20.4048C19.3952 20.4048 19.5465 20.3746 19.6876 20.3158C19.8287 20.257 19.9567 20.1709 20.0643 20.0624C20.1729 19.9547 20.259 19.8267 20.3178 19.6856C20.3766 19.5445 20.4068 19.3932 20.4068 19.2403C20.4068 19.0875 20.3766 18.9362 20.3178 18.7951C20.259 18.654 20.1729 18.526 20.0643 18.4183L15.0859 13.4514Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.f64805319101b389c9be2ec648280c08.svg";
export { ForwardRef as ReactComponent };